function initIvaajV2(){
 const root=document.getElementById('ivaaj-v2-product');
 if(!root||root.dataset.initialized)return;
 root.dataset.initialized='true';
 const $=id=>root.querySelector('#iv2-'+id);
 const catalog=JSON.parse(document.getElementById('iv2-catalog').textContent);
 const words=JSON.parse(document.getElementById('iv2-translations').textContent);
 const t=(key,values={})=>Object.entries(values).reduce((str,[k,v])=>str.replaceAll('{'+k+'}',String(v)),words[key]||key);
 const el=(tag,cls,value)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(value!==undefined)n.textContent=value;return n;};
 const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:catalog.currency||'GBP'}).format(value/100);
 const sized=(url,width)=>{const u=new URL(url,location.origin);u.searchParams.set('width',String(width));return u.href;};
 const norm=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
 const imageKey=im=>norm((String(im.alt||'').match(/#(?:colou?r|finish|size)_([^#]+)/i)||[])[1]||im.alt);
 const groupNames=new Set(catalog.variants.flatMap(v=>[v.name,...v.options]).map(norm));
 const variants=catalog.variants.map(v=>{const keys=new Set([v.name,...v.options].map(norm));const matched=catalog.images.some(im=>keys.has(imageKey(im)));const grouped=catalog.images.filter(im=>!matched||keys.has(imageKey(im))||!groupNames.has(imageKey(im)));const featured=catalog.images.find(im=>String(im.id)===String(v.featured));const photos=(featured?[featured,...grouped.filter(im=>im.id!==featured.id)]:grouped).map(im=>im.url);return {...v,photos};});
 let active=Math.max(0,variants.findIndex(v=>String(v.id)===String(catalog.selectedId))),photoIndex=0,quantity=1,previousFocus=null;
 const current=()=>variants[active];
 // Image captions: image colour tag > selected colour/finish > product specs.
 // Never show Shopify's generic "Default Title".
 const cleanColour=value=>{
   const str=String(value==null?'':value).replace(/\s+/g,' ').replace(/[.,;:]\s*$/,'').trim();
   return str && !/^(default(?: title)?|title|n\/a|none|not specified|one size|as shown|standard)$/i.test(str) ? str : '';
 };
 const colourIndex=(catalog.optionNames||[]).findIndex(name=>/^(colou?r|finish|shade|fabric colou?r|upholstery colou?r|wood finish|frame colou?r|colou?r\s*\/\s*finish)$/i.test(String(name).trim()));
 const textOf=node=>{
   if(!node)return '';
   if(typeof node==='string')return node;
   if(Array.isArray(node))return node.map(textOf).join('');
   return (typeof node.value==='string'?node.value:'')+(Array.isArray(node.children)?node.children.map(textOf).join(''):'');
 };
 const specColour=(()=>{
   let data=catalog.specifications;
   if(typeof data==='string'){
     try{data=JSON.parse(data);}catch{return cleanColour((data.match(/(?:^|\n)\s*(?:colou?r|finish|shade)\s*:\s*([^\n]+)/i)||[])[1]);}
   }
   if(!data || !Array.isArray(data.children))return '';
   for(const block of data.children){
     const line=textOf(block).trim();
     const matched=line.match(/^(?:colou?r|finish|shade|fabric colou?r|upholstery colou?r)\s*:\s*(.{1,90})$/i);
     if(matched){
       const colour=cleanColour(matched[1]);
       if(colour)return colour;
     }
   }
   return '';
 })();
 const knownColours=[
   'Rustic Brown','Walnut Brown','Dark Walnut','Light Walnut','Natural Walnut',
   'Natural Oak','Dark Oak','Light Oak','Dark Brown','Light Brown',
   'Charcoal Grey','Dark Grey','Light Grey','Warm Grey',
   'Charcoal','Anthracite','Terracotta','Espresso','Mahogany',
   'Walnut','Natural','Oak','Cream','Beige','Taupe','Mocha','Tan',
   'White','Black','Grey','Gray','Brown','Green','Blue','Navy',
   'Pink','Gold','Silver','Yellow','Orange','Red'
 ];
 const recogniseColour=text=>{
   const value=cleanColour(text);
   if(!value)return '';
   const matches=knownColours.filter(c=>new RegExp('(^|[^a-z])'+c+'(?=$|[^a-z])','i').test(value));
   return matches.length?matches[0]:'';
 };
 const titleColour=recogniseColour(catalog.productTitle||'');
 const imagesByUrl=new Map(catalog.images.map(image=>[image.url,image]));
 const photoColour=(v,index)=>{
   const url=v.photos[index];
   const alt=String(imagesByUrl.get(url)?.alt||'').trim();
   const tagged=alt.match(/#(?:colou?r|finish)_([^#]+)/i);
   if(tagged){
     const label=cleanColour(tagged[1].replace(/[_-]+/g,' '));
     if(label)return label;
   }
   if(colourIndex>=0){
     const option=cleanColour(v.options?.[colourIndex]);
     if(option)return option;
   }
   const suitableOptions=(catalog.optionNames||[]).map((name,i)=>{
     if(/^(size|quantity|qty|number|pack|set|seats|seater|dimensions|length|height|width|depth|title)$/i.test(name))return '';
     return cleanColour(v.options?.[i]);
   }).filter(Boolean);
   if(suitableOptions.length===1 && v.name!=='Default Title'){
     const likely=recogniseColour(suitableOptions[0]);
     if(likely)return suitableOptions[0];
   }
   const fromAlt=alt && alt.length<=48 ? recogniseColour(alt) : '';
   if(fromAlt)return fromAlt;
   if(specColour)return specColour;
   if(titleColour)return titleColour;
   return 'Product image';
 };
 const reducedMotion=matchMedia('(prefers-reduced-motion:reduce)').matches;
 root.classList.add('enhanced');
  const gallery=$('galleryTrack')||el('div','iv2-gallery-track');
  gallery.id='iv2-galleryTrack';gallery.tabIndex=0;
  gallery.setAttribute('role','region');gallery.setAttribute('aria-label',$('mainPhoto').getAttribute('aria-label')||'Product photos');
  const initialHero=$('heroImage');
  if(!gallery.isConnected)$('mainPhoto').prepend(gallery);
  let galleryTimer,galleryBuilt=false,firstPhotoPainted=false;
  const afterFirstPhotoPaint=callback=>{
    if(firstPhotoPainted||galleryBuilt){callback();return;}
    const run=()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{firstPhotoPainted=true;callback();}));
    if(!initialHero||initialHero.complete)run();
    else{initialHero.addEventListener('load',run,{once:true});initialHero.addEventListener('error',run,{once:true});}
  };
  afterFirstPhotoPaint(()=>root.querySelectorAll('.iv2-video-player').forEach(player=>{
    const video=player.querySelector('video'),button=player.querySelector('.iv2-video-toggle');
    if(!video||!button)return;
    const playIcon=button.querySelector('[data-video-play]'),pauseIcon=button.querySelector('[data-video-pause]');
    const sync=()=>{
      const paused=video.paused||video.ended;
      button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
      playIcon.toggleAttribute('hidden',!paused);pauseIcon.toggleAttribute('hidden',paused);
    };
    button.addEventListener('click',()=>{
      if(video.paused||video.ended)video.play().catch(sync);
      else video.pause();
    });
    ['play','pause','ended','error'].forEach(event=>video.addEventListener(event,sync));
    sync();button.hidden=false;
  }));
  function loadPhoto(index){
    const im=gallery.children[index]?.querySelector('img'),url=current().photos[index];
    if(!im||!url||im.dataset.ready)return;
    im.dataset.ready='true';
    // Keep Shopify's server-rendered LCP image request; rewriting srcset here
    // could cause a second download just as the hero is loading.
    if(im===initialHero&&im.getAttribute('src')&&new URL(im.src).pathname===new URL(url,location.href).pathname)return;
    im.decoding='async';
    im.sizes='(max-width: 800px) 100vw, (min-width: 1700px) 800px, 48vw';
    im.srcset=[360,480,640,720,768,960,1200,1600].map(w=>`${sized(url,w)} ${w}w`).join(', ');
    im.src=sized(url,1200);
  }
  function updatePhotos(){
    const v=current();if(!v.photos.length)return;
    loadPhoto(photoIndex);
    $('imageIndex').textContent=String(photoIndex+1).padStart(2,'0');
    $('imageTotal').textContent=String(v.photos.length).padStart(2,'0');
    [...$('thumbnails').children].forEach((b,i)=>{
      b.setAttribute('aria-current',String(i===photoIndex));
      if(i===photoIndex){const strip=$('thumbnails');strip.scrollTo({left:Math.max(0,b.offsetLeft-strip.offsetLeft),behavior:reducedMotion?'instant':'smooth'});}
    });
    if($('lightbox').classList.contains('open'))paintZoom();
  }
  function buildGallery(){
    clearTimeout(galleryTimer);
    const keepHero=!galleryBuilt&&initialHero?.closest('.iv2-gallery-slide')?.parentElement===gallery;
    if(!keepHero)gallery.replaceChildren();
    current().photos.forEach((url,i)=>{
      if(i===0&&keepHero){initialHero.dataset.reused='true';initialHero.alt=t('photo_label',{finish:photoColour(current(),i),index:1,count:current().photos.length});return;}
      const slide=el('div','iv2-gallery-slide');
      const im=i===0&&initialHero&&!initialHero.dataset.reused?initialHero:el('img');
      if(im===initialHero)im.dataset.reused='true';
      im.width=1200;im.height=1200;im.draggable=false;im.fetchPriority='low';
      im.alt=t('photo_label',{finish:photoColour(current(),i),index:i+1,count:current().photos.length});
      slide.append(im);gallery.append(slide);
    });
    galleryBuilt=true;gallery.scrollTo({left:0,behavior:'instant'});
  }
  function selectPhoto(n){
    if(!current().photos.length)return;
    photoIndex=(n+current().photos.length)%current().photos.length;
    const nextImage=gallery.children[photoIndex]?.firstElementChild;if(nextImage)nextImage.fetchPriority='high';
    updatePhotos();
    gallery.scrollTo({left:photoIndex*gallery.clientWidth,behavior:reducedMotion?'instant':'smooth'});
  }
  gallery.addEventListener('scroll',()=>{
    clearTimeout(galleryTimer);
    galleryTimer=setTimeout(()=>{
      if(!gallery.clientWidth)return;
      photoIndex=Math.max(0,Math.min(current().photos.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));
      updatePhotos();
    },120);
  },{passive:true});
  gallery.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
      event.preventDefault();selectPhoto(photoIndex+(event.key==='ArrowRight'?1:-1));
    }
  });
  if('ResizeObserver'in window)new ResizeObserver(()=>{
    gallery.scrollTo({left:photoIndex*gallery.clientWidth,behavior:'instant'});
  }).observe(gallery);
  function selectVariant(n){
    active=n;photoIndex=0;const v=current();
    $('finishLabel').replaceChildren(document.createTextNode(t('finish')+' '),el('span','selection','— '+v.name));
    $('variantHint').textContent=t('photos_selected',{finish:v.name,count:v.photos.length});
    $('stickyVariant').textContent=(root.dataset.defaultVariant==='true'?'':v.name+' · ')+money(v.price);
    const stickyImage=$('stickyImage');
    const stickyUrl=v.photos[0]||catalog.images[0]?.url;
    if(stickyImage)afterFirstPhotoPaint(()=>{
      if(current().id!==v.id)return;
      if(stickyUrl){
        stickyImage.loading='eager';
        stickyImage.fetchPriority='low';
        stickyImage.src=sized(stickyUrl,160);
        stickyImage.srcset=sized(stickyUrl,160)+' 1x, '+sized(stickyUrl,320)+' 2x';
        stickyImage.alt=(document.querySelector('#iv2-mainPhoto img')?.alt)||v.name||'Product photo';
        stickyImage.hidden=false;
      }else{
        stickyImage.hidden=true;
        stickyImage.removeAttribute('src');
        stickyImage.removeAttribute('srcset');
      }
    });
    $('addMain').disabled=!v.available;$('addSticky').disabled=!v.available;
    [...$('variants').children].forEach((b,i)=>b.setAttribute('aria-pressed',String(i===n)));
    thumbnailObserver?.disconnect();
    $('thumbnails').replaceChildren();
    v.photos.forEach((url,i)=>{
      const b=el('button','thumb');b.type='button';b.setAttribute('aria-label',t('show_photo',{finish:photoColour(v,i),index:i+1}));
      const im=el('img');im.dataset.src=sized(url,130);im.alt='';im.width=81;im.height=81;im.loading='lazy';im.decoding='async';
      b.append(im);b.onclick=()=>selectPhoto(i);$('thumbnails').append(b);
    });
    observeThumbnails();
    if(galleryBuilt)['storyImage1','storyImage2','specImage'].forEach((id,i)=>{
      const im=$(id),url=v.photos[Math.min(i+1,v.photos.length-1)];if(!im||!url)return;
      im.src=sized(url,800);im.srcset=[420,800,1200].map(w=>`${sized(url,w)} ${w}w`).join(', ');im.sizes='(max-width: 540px) 100vw, 50vw';
      im.alt=t('photo_label',{finish:v.name,index:i+2,count:v.photos.length});im.decoding='async';im.width=800;im.height=800;
    });
    $('variantSelect').value=String(v.id);
    root.querySelector('[data-iv2-price]').textContent=money(v.price);
    root.querySelector('[data-iv2-compare]').textContent=v.compare>v.price?money(v.compare):'';
    root.querySelector('[data-iv2-saving]').textContent=v.compare>v.price?t('save',{amount:money(v.compare-v.price)}):'';
    root.querySelector('[data-iv2-saving]').hidden=v.compare<=v.price;
    root.querySelector('[data-iv2-stock]').textContent=t(v.available?'stock':'unavailable');
    $('addMain').textContent=$('addSticky').textContent=t(v.available?'add':'sold_out');
    const selectedUrl=new URL(location.href);selectedUrl.searchParams.set('variant',String(v.id));history.replaceState({},'',selectedUrl);
    buildGallery();updatePhotos();
  }
  // Only request thumbnails when they are visible inside the horizontal strip.
  // Native lazy loading fetches offscreen thumbnails inside overflow containers.
  const thumbnailStrip=$('thumbnails');
  const thumbnailObserver='IntersectionObserver' in window
    ? new IntersectionObserver(entries=>{
        for(const entry of entries){
          if(!entry.isIntersecting)continue;
          const img=entry.target;
          if(img.dataset.src){img.src=img.dataset.src;delete img.dataset.src;}
          thumbnailObserver.unobserve(img);
        }
      },{root:thumbnailStrip,rootMargin:'0px 96px',threshold:0.01})
    : null;
  const observeThumbnails=()=>afterFirstPhotoPaint(()=>{
    thumbnailStrip.querySelectorAll('img[data-src]').forEach(img=>{
      if(thumbnailObserver)thumbnailObserver.observe(img);
      else{img.src=img.dataset.src;delete img.dataset.src;}
    });
  });
  variants.forEach((v,i)=>{
    const b=el('button','variant');b.type='button';b.title=v.name;b.setAttribute('aria-label',t('select_finish',{finish:v.name}));b.setAttribute('aria-pressed',String(i===0));
    const im=el('img');if(v.photos[0])afterFirstPhotoPaint(()=>{im.src=sized(v.photos[0],150);});im.alt='';im.width=70;im.height=70;im.loading='lazy';im.decoding='async';im.fetchPriority='low';
    b.append(im);if(root.hasAttribute('data-default-variant')&&root.dataset.defaultVariant!=='true')b.append(el('span','iv2-option-name',v.name));b.onclick=()=>selectVariant(i);$('variants').append(b);
  });
  selectVariant(active);
  const prefetchNext=()=>{const im=gallery.children[photoIndex+1]?.firstElementChild;if(im)im.fetchPriority='low';loadPhoto(photoIndex+1);};
  if(root.dataset.productId==='10387686261034'){
    gallery.addEventListener('pointerenter',prefetchNext,{once:true});
    gallery.addEventListener('pointerdown',prefetchNext,{passive:true});
  }else{
    const afterHero=()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{if('requestIdleCallback'in window)requestIdleCallback(prefetchNext,{timeout:2000});else setTimeout(prefetchNext,600);}));
    if(initialHero?.complete&&initialHero.naturalWidth)afterHero();else initialHero?.addEventListener('load',afterHero,{once:true});
  }
  $('nextMain').addEventListener('pointerenter',prefetchNext,{once:true});

  $('prevMain').onclick=$('prevThumb').onclick=()=>selectPhoto(photoIndex-1);
  $('nextMain').onclick=$('nextThumb').onclick=()=>selectPhoto(photoIndex+1);
  function setQuantity(n){quantity=Math.max(1,Math.min(10,n));$('qtyValue').textContent=quantity;$('quantityInput').value=String(quantity);$('qtyMinus').disabled=quantity===1;$('qtyPlus').disabled=quantity===10;}
  $('qtyMinus').onclick=()=>setQuantity(quantity-1);$('qtyPlus').onclick=()=>setQuantity(quantity+1);setQuantity(1);

 const form=document.getElementById('iv2-product-form');let adding=false;
 form.addEventListener('submit',async event=>{
  event.preventDefault();if(adding||!current().available)return;
  adding=true;const chosen=current(),addedQuantity=quantity;
  root.querySelectorAll('[data-iv2-add]').forEach(b=>{b.disabled=true;b.textContent=t('adding');});$('cartStatus').replaceChildren();
  let accepted=false,pending,CartErrorEvent;
  try{
   const events=await import('@shopify/events');
   const CartLinesUpdateEvent=events.CartLinesUpdateEvent;CartErrorEvent=events.CartErrorEvent;
   pending=CartLinesUpdateEvent.createPromise();pending.promise.catch(()=>{});
   form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(chosen.id),quantity:addedQuantity}],promise:pending.promise}));
   const body=new FormData(form);
   const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n=>n.dataset.sectionId))];
   if(sections.length)body.set('sections',sections.join(','));
   body.set('sections_url',location.pathname+location.search);
   const response=await fetch(root.dataset.cartAdd.replace(/\.js$/,'')+'.js',{method:'POST',body,headers:{Accept:'application/json'},credentials:'same-origin'});
   const result=await response.json();
   if(!response.ok||result.status)throw new Error(result.description||result.message||t('cart_error'));
   accepted=true;
   const cartResponse=await fetch(root.dataset.cartUrl.replace(/\.js$/,'')+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
   if(!cartResponse.ok)throw new Error(t('cart_refresh'));
   const cart=await cartResponse.json();
   pending.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:form.id,itemCount:addedQuantity,productId:root.dataset.productId,sections:result.sections,didError:false}});
   $('cartStatus').append(document.createTextNode(t('added')+' '));
   const link=el('a','inline-link',t('view_bag'));link.href=root.dataset.cartUrl;$('cartStatus').append(link);
   if(!document.querySelector('cart-drawer-component[auto-open]'))location.assign(root.dataset.cartUrl);
  }catch(error){
   pending?.reject(error);
   if(accepted){$('cartStatus').textContent=t('cart_refresh')+' ';const link=el('a','inline-link',t('view_bag'));link.href=root.dataset.cartUrl;$('cartStatus').append(link);}
   else{$('cartStatus').textContent=error.message||t('cart_error');if(CartErrorEvent)form.dispatchEvent(new CartErrorEvent({error:error.message,code:'SERVICE_UNAVAILABLE'}));}
  }finally{adding=false;root.querySelectorAll('[data-iv2-add]').forEach(b=>{b.disabled=!current().available;b.textContent=t(current().available?'add':'sold_out');});}
 });
 $('addSticky').onclick=()=>form.requestSubmit();
 function paintZoom(){const v=current(),colour=photoColour(v,photoIndex);$('lightboxImage').src=v.photos[photoIndex];$('lightboxImage').alt=t('photo_label',{finish:colour,index:photoIndex+1,count:v.photos.length});$('lightboxCount').textContent=colour+' · '+(photoIndex+1)+' / '+v.photos.length;}
 $('expandPhoto').onclick=()=>{previousFocus=document.activeElement;paintZoom();$('lightbox').classList.add('open');$('lightbox').setAttribute('aria-hidden','false');document.body.style.overflow='hidden';$('lightboxClose').focus();};
 function closeZoom(){$('lightbox').classList.remove('open');$('lightbox').setAttribute('aria-hidden','true');document.body.style.overflow='';previousFocus?.focus();}
 $('lightboxClose').onclick=closeZoom;$('lightboxPrev').onclick=()=>selectPhoto(photoIndex-1);$('lightboxNext').onclick=()=>selectPhoto(photoIndex+1);
 if('IntersectionObserver'in window)new IntersectionObserver(([entry])=>$('sticky').classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.top<0),{threshold:.01}).observe($('buyArea'));
 let reviewModulePromise;
 const prepareReviews=()=>{
  if(root.dataset.reviewCount==='0')return;
  if(!reviewModulePromise)reviewModulePromise=import(root.dataset.reviewsModule).then(m=>m.initReviews(root,words)).catch(()=>{reviewModulePromise=null;});
  return reviewModulePromise;
 };
 const reviewSection=$('customer-feedback');
 if(reviewSection&&root.dataset.reviewCount!=='0'){
  if('IntersectionObserver'in window){
   const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();prepareReviews();}},{rootMargin:'500px 0px'});
   observer.observe(reviewSection);
  }else prepareReviews();
  root.querySelectorAll('a[href="#iv2-customer-feedback"],a[href="#iv2-reviewControls"]').forEach(a=>{
   a.addEventListener('pointerenter',prepareReviews,{once:true});a.addEventListener('focus',prepareReviews,{once:true});a.addEventListener('click',prepareReviews,{once:true});
  });
  $('retryReviews').onclick=prepareReviews;
 }
 document.addEventListener('keydown',event=>{
  if(!$('lightbox').classList.contains('open'))return;
  if(event.key==='Escape')closeZoom();if(event.key==='ArrowLeft')selectPhoto(photoIndex-1);if(event.key==='ArrowRight')selectPhoto(photoIndex+1);
  if(event.key==='Tab'){const buttons=[...$('lightbox').querySelectorAll('button')],first=buttons[0],last=buttons.at(-1);if(event.shiftKey&&document.activeElement===first){last.focus();event.preventDefault();}else if(!event.shiftKey&&document.activeElement===last){first.focus();event.preventDefault();}}
 });
}
// Let the server-rendered first photo paint before building the extra slides.
// A customer's first interaction still initializes the controls immediately.
function startIvaajV2(){
 const root=document.getElementById('ivaaj-v2-product');
 const hero=document.getElementById('iv2-heroImage');
 if(!root||root.dataset.productId!=='10387686261034'||!hero){initIvaajV2();return;}
 let queued=false;
 const start=()=>{
  root.removeEventListener('pointerdown',start,true);
  root.removeEventListener('keydown',start,true);
  initIvaajV2();
 };
 const afterPhoto=()=>{
  if(queued)return;
  queued=true;
  const decoded=hero.decode?hero.decode().catch(()=>{}):Promise.resolve();
  decoded.then(()=>requestAnimationFrame(()=>requestAnimationFrame(start)));
 };
 root.addEventListener('pointerdown',start,{capture:true,once:true});
 root.addEventListener('keydown',start,{capture:true,once:true});
 if(hero.complete)afterPhoto();
 else{
  hero.addEventListener('load',afterPhoto,{once:true});
  hero.addEventListener('error',start,{once:true});
 }
}
startIvaajV2();
document.addEventListener('shopify:section:load',initIvaajV2);



